import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import CustomExpandableTable from "../../../../components/table/CustomExpandableTable";
import NotInformation from "../../../../components/NotInformation";
import React from "react";
import {RequestTabApp} from "../Funtionality/RequestTabApp";
import RenderExpandedRow from "./RenderExpandedRow";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const RequestTab = ({
                        contractorId,
                        supplierId,
                        setShowDeleteModal,
                        setShowAcceptRequest,
                        setShowDepartureComment,
                        setRow,
                        modified,
                        setModified
                     }) => {


    const {
        searchElement,
        setSearchElement,
        setBodyForExport,
        setSearchResults,
        option,
        rowsPerPage,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        searchResults,
        selectedList,
        searchId,
        columns,
        handleCheckboxChange,
        pagination,
        handleDeleteAll,
        renderOptionsMenu,
        handleRowExpand,
        t
    } = RequestTabApp({
        supplierId,
        setShowDeleteModal,
        setShowAcceptRequest,
        setShowDepartureComment,
        setRow,
        modified,
        setModified
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
                viewType={1}
            />
            {searchResults?.content?.length > 0 ? (
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        checkbox={false}
                        columns={columns}
                        rows={searchResults?.content || []}
                        renderExpandedRow={RenderExpandedRow}
                        renderOptionsMenu={renderOptionsMenu}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation card={true} text={t('no_information')}/>
            )}
        </>
    )
}

export default RequestTab
